import intl from 'react-intl-universal'

const checkLanguage = () => {
  return intl.determineLocale({
      urlLocaleKey: "lang",
      cookieLocaleKey: "lang"
    })
}

export default (state = { lang: checkLanguage() }, action) => {
  switch(action.type) {
    case 'CHANGE/LANG': {
      const type = action.data.data
      if(type === 'zh') {
        if(state.lang !== 'zh-CN') {
          const newLang = 'zh-CN'
          window.location.search = `?lang=${newLang}`
        }
      } else if(type === 'en') {
        if(state.lang !== 'en-US') {
          const newLang = 'en-US'
          window.location.search = `?lang=${newLang}`
        }
      }
      return {...state}
    }
    default: {
      return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/universal/reducer.js